import { campaignTemplatesConstants } from '@constants/campaignTemplates';
import { campaignTemplatesService } from '@services';

function request() {
    return { type: campaignTemplatesConstants.CAMPAIGN_TEMPLATES_FETCH };
}

function success(data) {
    return { type: campaignTemplatesConstants.CAMPAIGN_TEMPLATES_SUCCESS, data };
}

function failure(message) {
    return { type: campaignTemplatesConstants.CAMPAIGN_TEMPLATES_ERROR, message };
}

// Archived templates are included by default: the Library needs them for unarchive, and the
// campaign editor needs their binding metadata for existing campaigns that still reference
// them. Pickers filter archived entries client-side.
const get = (search = '', includeArchived = true) => {
    return dispatch => {
        dispatch(request());
        campaignTemplatesService.getTemplates(search, includeArchived).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

export const campaignTemplatesActions = {
    get,
};
